import React, { useState } from 'react';
import '../../style/style.css';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Alert, Button, Form, FormGroup, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ToastComponent from '../toastComponent'; // Renamed to avoid conflict with react-bootstrap/Toast

// Os ícones podem ser do bootstrap-icons, font-awesome, ou SVGs customizados.
// Por simplicidade, usaremos texto.
library.add(fas);

const ModalFilters = ({ showConfigModal, setShowConfigModal, isTyping, queryType, setQueryType, startDate, setStartDate, availableQueryTypes, endDate, setEndDate, maxDaysFilter }) => {
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showErrorToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const validateModalFilters = async () => {
        const differenceInMs = endDate - startDate;
        const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);

        // if (differenceInDays > maxDaysFilter) {
        //     const errorMessage = "O intervalo máximo permitido é de " + maxDaysFilter + " dias.";
        //     setError(errorMessage);
        // } else {
            setError();
            await sendDataToAssistant();
            // setShowConfigModal(false);
        // }
    }

    const sendDataToAssistant = async () => {
        setIsLoading(true);
        sessionStorage.removeItem('OpenAi_UploadedFileIds');
        try {
            if (queryType == 0) {
                throw new Error("Selecione uma consulta válida!");
            }

            const request = {
                queryType,
                startDate,
                endDate,
                threadId: sessionStorage.getItem("OpenAi_threadId"),
                database: window.database_type,
                userName: localStorage.getItem("RC_USR_PORTAL"),
            };

            const response = await fetch(`${window.ai_api_service}api/OpenAi/SendSearchData`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request)
            });

            if (!response.ok) {
                const errorData = await response.json();

                throw new Error(`Erro na API: ${response.status} - ${errorData.message}`);
            }

            const responseData = await response.json();

            let uploadedIds = [];

            const existingIds = sessionStorage.getItem('OpenAi_UploadedFileIds');
            if (existingIds) {
                try {
                    uploadedIds = JSON.parse(existingIds);
                    if (!Array.isArray(uploadedIds)) uploadedIds = [];
                } catch {
                    uploadedIds = [];
                }
            }
            uploadedIds.push(responseData.fileId);

            sessionStorage.setItem('OpenAi_UploadedFileIds', JSON.stringify(uploadedIds));

            setToastMessage("Dados enviados para o assistente com sucesso!");
            setShowToast(true);
            setShowConfigModal(false);

        } catch (error) {
            console.error('Erro ao enviar os dados para o assistente:', error);
            setError("Erro ao enviar dados para o assistente! " + error);

        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <Modal show={showConfigModal} onHide={() => setShowConfigModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enviar dados para o assistente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <Form.Label>Consulta SQL?</Form.Label>
                        <Form.Control as="select" value={queryType}
                            onChange={e => setQueryType(Number(e.target.value))}>
                            {availableQueryTypes.map(type => (
                                <option key={type.id} value={type.id}>
                                    {type.nomeConsulta}
                                </option>
                            ))}
                        </Form.Control>
                    </FormGroup>

                    <FormGroup>
                        <Form.Label>Data Inicial</Form.Label>
                        <Form.Control
                            type="date"
                            value={startDate ? startDate.toISOString().split('T')[0] : ''}
                            onChange={e => setStartDate(new Date(e.target.value))}
                            disabled={isTyping}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Form.Label>Data Final</Form.Label>
                        <Form.Control
                            type="date"
                            value={endDate.toISOString().split('T')[0]}
                            onChange={e => setEndDate(new Date(e.target.value))}
                            disabled={isTyping}
                        />
                    </FormGroup>

                </Modal.Body>
                {/* The Alert component can remain if you want to show a persistent error inside the modal */}
                {error &&
                    <Alert variant={'danger'} className='mr-2 ml-2'>
                        <FontAwesomeIcon icon="exclamation-circle" className="mr-2" />
                        {error}
                    </Alert>
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfigModal(false)}>
                        Fechar
                    </Button>

                    <Button variant="primary" onClick={() => validateModalFilters()} disabled={isLoading}>
                        {isLoading ? 'Enviando...' : 'Enviar'}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Toast component for errors */}
            <ToastComponent
                show={showErrorToast}
                setShow={setShowToast}
                title="Dados Enviados!"
                content={toastMessage}
            />
        </>
    );
};

export default ModalFilters;